import { render, staticRenderFns } from "./admin.layout.vue?vue&type=template&id=08ac2407&scoped=true&"
import script from "./admin.layout.vue?vue&type=script&lang=js&"
export * from "./admin.layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac2407",
  null
  
)

export default component.exports